import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyDashboardPreview = loadable(() => import(/* webpackChunkName: "content/admin/preview" */ './DashboardPreview'), 'DashboardPreviewProvider');
